import { NgModule } from '@angular/core';
import { provideRouter, withComponentInputBinding } from '@angular/router';
import { LayoutEmptyComponent } from '../common/components/layout-empty/layout-empty.component';
import { LayoutDefaultComponent } from '../common/components/layout-default/layout-default.component';
import { UserAuthGuard } from './guards/user-auth-guard';
import { ErpDashboardGuard } from './guards/erp-dashboard-guard';
import { PermissionGuard } from '../../core/guards/permission.guard';
import { defaultDashboardRedirect } from './guards/default-dashboard.guard';

@NgModule({
  declarations: [],
  imports: [],
  providers: [
    provideRouter([
      {
        path: 'dashboard',
        component: LayoutDefaultComponent,
        canActivate: [UserAuthGuard],
        children: [
          {
            // `/dashboard` opens the profile's default home dashboard (Payments when unset or not
            // available to this user). The guard always redirects, so the component never renders.
            path: '',
            pathMatch: 'full',
            canActivate: [defaultDashboardRedirect],
            children: [],
          },
          {
            path: 'payments',
            loadComponent: () => import('./pages/dashboard/dashboard.component').then((x) => x.DashboardComponent),
          },
          {
            path: 'erp',
            canActivate: [ErpDashboardGuard],
            loadComponent: () => import('./pages/erp-dashboard/erp-dashboard.component').then((x) => x.ErpDashboardComponent),
          },
          {
            path: 'ledger',
            canActivate: [PermissionGuard],
            data: { permissions: 'GET_TRANSACTION_STATS' },
            loadComponent: () =>
              import('./pages/ledger-dashboard/ledger-dashboard.component').then((x) => x.LedgerDashboardComponent),
          },
          {
            path: 'ach',
            loadComponent: () => import('./pages/ach-dashboard/ach-dashboard.component').then((x) => x.AchDashboardComponent),
          },
          {
            path: 'credit-card',
            loadComponent: () =>
              import('./pages/credit-card-dashboard/credit-card-dashboard.component').then(
                (x) => x.CreditCardDashboardComponent,
              ),
          },
          {
            path: 'schedule-payments',
            loadComponent: () =>
              import('./pages/schedule-payments-dashboard/schedule-payments-dashboard.component').then(
                (x) => x.SchedulePaymentsDashboardComponent,
              ),
          },
          {
            path: 'ar',
            loadComponent: () => import('./pages/invoice-dashboard/invoice-dashboard.component').then((x) => x.InvoiceDashboardComponent),
          },
        ],
      },
      {
        path: 'login',
        component: LayoutEmptyComponent,
        children: [
          {
            path: '',
            loadComponent: () => import('./pages/login/login.component').then((x) => x.LoginComponent),
          },
        ],
      },
      {
        path: 'forgot-password',
        component: LayoutEmptyComponent,
        children: [
          {
            path: '',
            loadComponent: () =>
              import('./pages/forgot-password/forgot-password.component').then((x) => x.ForgotPasswordComponent),
          },
        ],
      },
      {
        // agent-desktop SSO consume route (public — the one-time link is the credential).
        path: 'auth/agent-exchange',
        component: LayoutEmptyComponent,
        children: [
          {
            path: '',
            loadComponent: () =>
              import('./pages/agent-exchange/agent-exchange.component').then((x) => x.AgentExchangeComponent),
          },
        ],
      },
      {
        // Fallback download page when the desktop app is not installed (public route).
        path: 'download-desktop-agent',
        component: LayoutEmptyComponent,
        children: [
          {
            path: '',
            loadComponent: () =>
              import('./pages/download-desktop-agent/download-desktop-agent.component').then(
                (x) => x.DownloadDesktopAgentComponent,
              ),
          },
        ],
      },
      {
        path: 'change-password-required',
        component: LayoutEmptyComponent,
        canActivate: [UserAuthGuard],
        children: [
          {
            path: '',
            loadComponent: () =>
              import('./pages/change-password-required/change-password-required.component').then(
                (x) => x.ChangePasswordRequiredComponent,
              ),
          },
        ],
      },
    ]),
  ],
})
export class UserRoutingModule {}
